module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement01-bd7ebdf61415e2d8672f66f2d524dc3f.jpg";